import type { ReactNode } from "react";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import "./DropDownMenuItem.scss";
import type { IconComponent } from "@/shared/components/generic/IconComponentType.ts";
import classNames from "classnames";

export interface DropDownMenuItemProps {
  selected?: boolean;
  onClick: () => void;
  label: string;
  icon?: IconComponent;
  active?: boolean;
}

export default function DropDownMenuItem({
  selected,
  onClick,
  label,
  icon,
  active = true,
}: DropDownMenuItemProps): ReactNode {
  function iconClasses(): string | undefined {
    return classNames("icon", active ? "active" : "inactive");
  }
  const iconComponent = icon?.({
    className: iconClasses(),
  });

  return (
    <div className="menu-item">
      <MenuItem selected={selected} onClick={onClick} disabled={!active}>
        {icon && <ListItemIcon>{iconComponent}</ListItemIcon>}
        <ListItemText className={active ? "active" : "inactive"}>
          {label}
        </ListItemText>
      </MenuItem>
    </div>
  );
}
